import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { FaCircleExclamation } from "react-icons/fa6";
import horusLogo from "../../../assets/imgs/login/logo-horus.png";
import InstallBanner from "../components/InstallBanner";
import { loginLiftTruck } from "../services/liftApi";
import { saveLiftSession } from "../services/liftSession";
import "./login.css";

// Mismo texto que login.blade.php muestra para "no existe el montacarguista"
// y "pin incorrecto" (el PHP no distingue entre ambos en pantalla).
const INVALID_CREDENTIALS_MESSAGE = "Información incorrecta, favor de validar";

// Réplica del flujo de amcmontacargas-L8.8 (PWAController::postLogin): dos
// campos, employee_number + pin, y el backend resuelve las 3 salidas
// posibles (login OK / no existe el montacarguista / pin incorrecto).
function MontacargasLogin() {
  const navigate = useNavigate();
  const [employeeNumber, setEmployeeNumber] = useState("");
  const [pin, setPin] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrorMessage("");

    if (!employeeNumber.trim() || !pin.trim()) {
      setErrorMessage(INVALID_CREDENTIALS_MESSAGE);
      return;
    }

    setSubmitting(true);

    try {
      const response = await loginLiftTruck({ employee_number: employeeNumber.trim(), pin: pin.trim() });
      saveLiftSession(response.data);
      navigate("/montacargas/home");
    } catch (error) {
      const status = error.response?.status;
      setErrorMessage(
        status === 400 || status === 401
          ? INVALID_CREDENTIALS_MESSAGE
          : "No se pudo iniciar sesión, intenta de nuevo.",
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="mc-login">
      <div className="mc-login__hero">
        <img src={horusLogo} alt="Horus" className="mc-login__logo" />
      </div>

      <div className="mc-login__body">
        <form className="mc-login__form" onSubmit={handleSubmit} noValidate>
          <p className="mc-login__title">Introduce tu usuario y contraseña</p>

          <div className="mc-field mc-field--accent">
            <input
              id="montacargas-employee-number"
              type="text"
              className="mc-field__input"
              placeholder=" "
              value={employeeNumber}
              onChange={(event) => setEmployeeNumber(event.target.value)}
              autoComplete="username"
              autoCapitalize="off"
              disabled={submitting}
              required
            />
            <label className="mc-field__label" htmlFor="montacargas-employee-number">
              Número de empleado
            </label>
          </div>

          <div className="mc-field">
            <input
              id="montacargas-pin"
              type="text"
              inputMode="numeric"
              className="mc-field__input"
              placeholder=" "
              value={pin}
              onChange={(event) => setPin(event.target.value)}
              autoComplete="off"
              disabled={submitting}
              required
            />
            <label className="mc-field__label" htmlFor="montacargas-pin">
              Pin del día
            </label>
          </div>

          {errorMessage && (
            <div className="mc-alert mc-login__alert" role="alert">
              <FaCircleExclamation aria-hidden="true" />
              <span>{errorMessage}</span>
            </div>
          )}

          <button type="submit" className="mc-btn-primary mc-login__submit" disabled={submitting}>
            {submitting ? (
              <>
                <Spinner animation="border" size="sm" />
                Ingresando...
              </>
            ) : (
              "Iniciar sesión"
            )}
          </button>
        </form>

        <InstallBanner />
      </div>
    </div>
  );
}

export default MontacargasLogin;
